import styled from 'styled-components';

export const RowBut = styled.div `
  margin-top:2em;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

